import React from 'react';
import { Icon } from 'next/components/ui';
import appcuesWidget from 'appcues-widget';

const WidgetLink = () => {
  if (!window.Appcues) {
    return null;
  }

  const widget = appcuesWidget(
    window.Appcues.user().then(user => {
      const { _appcuesId: appcuesId } = user;
      return { ...user, appcuesId };
    })
  );

  widget.init('#widget-root', {
    position: 'top-right',
    header: "<h3 class='appcues-widget-header-text'>Resources</h3>",
  });

  return (
    <li id="widget-root">
      <div className="appcues-widget-icon" role="button">
        <Icon icon="list" title="Resources" />
      </div>
    </li>
  );
};

export default WidgetLink;
